import cx from 'classnames'
import Styles from './PropertyForm.module.scss'
import { ReactComponent as TrashIcon } from 'assets/icons/trash16.svg'
import { Property } from 'api/clients/PropertyClient'
import { Button } from 'blaze-ui/Button'

interface Props {
  isEdit: boolean
  property: Property | undefined
  onCreate?: (property: Property) => void
  onUpdate?: (property: Property) => void
  onRemove?: (property: Property) => void
  isSubmitting: boolean
  isValid: boolean
  removeText: string
}

const FormButtons = ({ property, isEdit, onCreate, isSubmitting, isValid, onRemove, onUpdate, removeText }: Props) =>
  !isEdit ? (
    <>
      {onCreate && (
        <>
          <div className={cx(Styles.actionDivider, Styles.marginExtra)}></div>
          <div className={Styles.buttonGroup}>
            <Button
              size="md"
              type="submit"
              aria-label="Create property"
              isDisabled={!isValid || isSubmitting}
              fullWidth
            >
              Add Property
            </Button>
          </div>
        </>
      )}
    </>
  ) : (
    <div className={Styles.buttonGroup}>
      {onRemove && (
        <Button variant="tertiary" size="md" isDisabled={isSubmitting} onPress={() => onRemove(property as Property)}>
          <TrashIcon className={Styles.inputIcon} />
          {removeText}
        </Button>
      )}
      {onUpdate && (
        <Button size="md" type="submit" aria-label="Update" isDisabled={!isValid || isSubmitting} fullWidth={!onRemove}>
          Save
        </Button>
      )}
    </div>
  )

export default FormButtons
